import apiHandler from "../core/apiHandler";

const importApi = apiHandler('imports');
export default importApi;
